export default "__VITE_ASSET__hThAcr1Y__"